import React from "react";
import {Typography} from '@mui/material';
import {Link} from "react-router-dom";
import {Box} from "@mui/material";
import processPlaceholder from "../../../common/Message/Utilities/MessageUtils";
import styles from "./Styles.module.css"
import BasicTooltip from "../../../common/BasicTooltip";

export default function ParsedText({text, messageId, messageType}){
    let parsedMessage = processPlaceholder(text);

    return(
        <BasicTooltip
            title={
                <Box className={styles.tooltipTitleWrapper}>
                    <Typography className={styles.tooltipTypography}>
                        {parsedMessage}
                    </Typography>
                </Box>
            }
            enterDelay={700}
        >
            <Link to={`/inbox/${messageId}?type=${messageType}`} className="tms-no-underline">
                <Box sx={{color: "#0C2728", fontSize: "14px"}} >
                    {parsedMessage}
                </Box>
            </Link>
        </BasicTooltip>
    )
}